import { useHead, useJsonld } from '#imports'
import { useGlobalStore } from '@/stores'

export default function useSeo(keyword: string, total: number) {
  const globalStore = useGlobalStore()
  globalStore.setBreadcrumbs([{ title: '搜尋結果', isActive: true, url: `/search` }])

  const title = `搜尋結果｜${import.meta.env.VITE_WEBSITE_TITLE}`
  const description = globalStore.seoDescriptions.search.replace(':keyword', keyword).replace(':total', total.toString())

  useSeoMeta({
    title: title,
    ogTitle: title,
    description: description,
    ogDescription: description
    // ogImage: faq.value.seo?.og_image?.link,
    // keywords: faq.value.seo?.meta_keywords.join(',')
  })

  useHead({
    link: [
      {
        rel: 'canonical',
        href: `${import.meta.env.VITE_DOMAIN}/search`
      }
    ]
  })

  useJsonld({
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: '首頁',
            item: import.meta.env.VITE_DOMAIN
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: '搜尋結果',
            item: `${import.meta.env.VITE_DOMAIN}/search`
          }
        ]
      }
    ]
  })
}
